/* eslint-disable no-mixed-spaces-and-tabs */
import React from "react";

import { GroupLayout, LayoutProps, rankWith, uiTypeIs } from "@jsonforms/core";
import { withJsonFormsLayoutProps } from "@jsonforms/react";

import { Box, Card, CardContent, CardHeader, Typography } from "@mui/material";
import { colourStaticDarkGrey } from "@ingka/variables/colours-css";

import { EditorLayout } from "../model/uischema";
import { DroppableLayout } from "./DroppableLayout";

const Group: React.FC<LayoutProps> = (props) => {
	const { uischema } = props;
	const groupLayout = uischema as GroupLayout & EditorLayout;

	return (
		<Card>
			<CardHeader
				component={() => (
					<Box
						sx={{
							p: 2,
							display: "flex",
							alignItems: "baseline",
							gap: 1,
						}}
					>
						<Typography>Label:</Typography>
						<Typography
							sx={{
								...(groupLayout.label
									? {}
									: {
											fontStyle: "italic",
											fontWeight: "lighter",
											color: colourStaticDarkGrey,
											fontSize: "20px",
									  }),
								whiteSpace: "nowrap",
								overflow: "hidden",
								textOverflow: "ellipsis",
							}}
						>
							{groupLayout.label ?? "no label"}
						</Typography>
					</Box>
				)}
			/>
			<CardContent>
				<DroppableLayout {...props} layout={groupLayout} direction={"column"} />
			</CardContent>
		</Card>
	);
};

export const DroppableGroupLayoutRegistration = {
	tester: rankWith(45, uiTypeIs("Group")),
	renderer: withJsonFormsLayoutProps(Group),
};
